export default function randomId(): string {
  return `${Math.random()}_${Date.now()}`.substring(2);
}
